// DoctorRoutes.js
import React from "react";
import { Outlet } from "react-router-dom";
import AuthGuard from "./AuthGuard";
import Header from "../components/header";
import Footer from "../components/Footer";
import { Roles } from "../constants";

function DoctorRoutes() {
  return (
    <>
      <AuthGuard role={Roles.DENTIST}>
        <Header />
        <Outlet />
        <Footer />
      </AuthGuard>
    </>
  );
}

export default DoctorRoutes;
